var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container media-gallery-list" },
    [
      _c(
        "global-loading-overlay",
        { attrs: { "show-loading": _vm.isLoading } },
        [_vm._v(_vm._s(_vm.$t("mediaGallery.loadMore.loadingText")))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "div",
            { staticClass: "media-gallery-list__result-count col-12" },
            [
              _c("p", [
                _vm._v(_vm._s(_vm.totalAssets) + " "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("mediaGallery.results.totalResults"))),
                ]),
              ]),
              _c("div", { staticClass: "media-gallery-list__decoration" }),
            ]
          ),
          _vm._v(" "),
          _vm.assets.length === 0
            ? _c(
                "div",
                { staticClass: "media-gallery-list__no-result col-12" },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("mediaGallery.results.noResult"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.assets, function (asset) {
            return _c(
              "div",
              { staticClass: "col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2" },
              [
                _c("media-gallery-asset", {
                  key: asset.id,
                  attrs: { asset: asset },
                  on: { showDetail: _vm.showDetail },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.getDetailAsset
        ? _c("global-modal", {
            attrs: { "lock-scrolling": true, "over-menu": true },
            on: { close: _vm.clearDetail },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("media-gallery-asset-modal", {
                        directives: [
                          {
                            name: "touch",
                            rawName: "v-touch:swipe.right",
                            value: _vm.showPreviousDetail,
                            expression: "showPreviousDetail",
                            arg: "swipe",
                            modifiers: { right: true },
                          },
                          {
                            name: "touch",
                            rawName: "v-touch:swipe.left",
                            value: _vm.showNextDetail,
                            expression: "showNextDetail",
                            arg: "swipe",
                            modifiers: { left: true },
                          },
                        ],
                        attrs: { asset: _vm.getDetailAsset },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "pagination",
                              fn: function () {
                                return [
                                  _c("global-button", {
                                    attrs: {
                                      icon: "arrow-left",
                                      theme: "ghost",
                                      disabled: _vm.disablePreviousDetail,
                                    },
                                    on: { click: _vm.showPreviousDetail },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.detailIndex + 1) +
                                        " " +
                                        _vm._s(
                                          _vm.$t("mediaGallery.loadMore.xOfY")
                                        ) +
                                        " " +
                                        _vm._s(_vm.totalAssets)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("global-button", {
                                    attrs: {
                                      icon: "arrow-right",
                                      theme: "ghost",
                                      disabled: _vm.disableNextDetail,
                                    },
                                    on: { click: _vm.showNextDetail },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "global-loading-overlay",
                                    {
                                      attrs: {
                                        "show-loading": _vm.hasRunningRequest(
                                          _vm.loadMoreRequestIdentifier
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mediaGallery.loadMore.loadingText"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2501593790
                        ),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              504222565
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }